import { render } from "./ParametricsView.vue?vue&type=template&id=62a56a08"
import script from "./ParametricsView.vue?vue&type=script&lang=js"
export * from "./ParametricsView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrateur\\Documents\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__